import { apiService } from './apiService';

export function getTransactionService(data) {
    return apiService({
        method: 'POST',
        url: '/transaction/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdTransactionService(id) {
    return apiService({
        method: 'GET',
        url: '/transaction/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addTransactionService(data) {
    return apiService({
        method: 'POST',
        url: '/transaction',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateTransactionService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/transaction/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteTransactionService(id) {
    return apiService({
        method: 'DELETE',
        url: '/transaction/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
